<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div *ngIf="(serverError === null) && documentTemplate">
  <nav class="navbar navbar-expand navbar-light bg-light doc-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/document-templates/" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link active" href="#"
           [class.text-muted]="loadingTemplate"
           (click)="$event.preventDefault();">
          Settings
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled text-muted" href="#"
           (click)="$event.preventDefault();">
          Content
        </a>
      </li>
    </ul>

    <form class="form-inline">
      <button *ngIf="!loadingTemplate" class="btn btn-primary btn-sm ml-2"
         type="button" (click)="handleSave()">
        Save
      </button>
      <button *ngIf="loadingTemplate" class="btn btn-primary btn-sm ml-2 disabled"
         type="button" disabled>
        Loading
      </button>
    </form>
  </nav>

  <app-document-template-edit-settings
    [(documentTemplate)]="documentTemplate" [documentTemplateErrors]="documentTemplateErrors">
  </app-document-template-edit-settings>

  <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="documentTemplateErrorMessage">
    {{ documentTemplateErrorMessage }}
    <button type="button" class="close" (click)="documentTemplateErrorMessage = ''">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
